import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'
import { Row, Col, Card, CardBody } from 'reactstrap';
import { FormGroup, Input, Label, Container, Alert, ContainerFluid } from 'reactstrap';
import { useCookies } from 'react-cookie';
import EntryFormV2 from '../components/EntryFormV2/EntryFormV2';
import ProgressV2 from '../components/EntryFormV2/Layout/ProgressV2';
import axios from 'axios';
import CustomToast from '../utils/CustomToast';
import PageSpinner from 'components/PageSpinner';
import { initialEntryFormData } from '../utils/InitialData';

const EntryFormPreviewPage = () => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    const category_id = query.get('category_id');
    const award_id = query.get('award_id');
    const page = query.get('page');

    const location = useLocation();
    var currentPathName = location.pathname;

    const [cookies, setCookies, removeCookies] = useCookies(['currentUser', 'isLoggedIn', 'awardStatus', 'isSubmit', 'token','award_id','section']);
    const currentUser = cookies.currentUser;
    const token = '54645f54gxec3r4vccwex4qzndy3cd2xnzs8mh2saa3se';
    const [award, setAward] = useState();
    const [awardLoading, setAwardLoading] = useState(true);
    const [category, setCategory] = useState(null);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState(initialEntryFormData);

    const [categoryQuestions, setCategoryQuestions] = useState([]);
    const [categoryQuestionLoading, setCategoryQuestionsLoading] = useState(true);

    const getAward = async () => {
        return await axios.get(
            process.env.REACT_APP_API_ENDPOINT + `award/${award_id}`,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const getQuestion = async (id) => {
        return await axios.get(
            process.env.REACT_APP_API_ENDPOINT + `category/${id}/category/question`,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const getCategory = async (id) => {
        return await axios.get(
            process.env.REACT_APP_API_ENDPOINT + `category/${id}`,
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    useEffect(() => {
        getAward().then(response => {
            const data = response.data.data;
            if (data) {
                setAward(data);
                setAwardLoading(false);
            } else {
                CustomToast.defaultWarning();
            }
        }).catch(() => {
            CustomToast.defaultError();
        });

        getCategory(category_id).then(response => {
            const data = response.data.data;
            if (data) {
                setCategory(data);
            } else {
                CustomToast.defaultWarning();
            }
        }).catch(() => {
            CustomToast.defaultError();
        });

        getQuestion(category_id).then(response => {
            const data = response.data;
            if (data) {
                setCategoryQuestions(data);
                setCategoryQuestionsLoading(false);
            } else {
                CustomToast.defaultWarning();
                setCategoryQuestionsLoading(false);
            }
        }).catch(() => {
            CustomToast.defaultError();
            setCategoryQuestionsLoading(false);
        });
        
    }, [])

    useEffect(() => {
        if (page && currentPathName == "/entry-form/preview") {
            setStep(Number(page));
        }
    }, [page])

    return (
        <>
            <section id="bis_award_tab" className="page-container">
                <Container>
                    <Alert color="warning" className="mb-4">
                        <p className='mb-0'>This page is just a preview of the entry form</p>
                    </Alert>
                    <Row>
                        {awardLoading || !category || categoryQuestionLoading ?
                            <>
                                <Col lg="12">
                                    <PageSpinner />
                                </Col>
                            </>
                            :
                            <>
                                <Col lg="3">
                                    <Card className="text-center award-sidebar mb-3">
                                        <CardBody>
                                            {award.logo != "" ?
                                                <img src={award.logo} alt={award.name} />
                                                :
                                                <PageSpinner />
                                            }
                                        </CardBody>
                                    </Card>
                                    {categoryQuestions ?
                                        <ProgressV2 stepPage={step} categoryQuestions={categoryQuestions} />
                                        :
                                        null
                                    } 
                                    
                                </Col>
                                <Col lg="9">
                                    <Row>
                                        <Col lg="12">
                                            <h2 className="award-header">{category.name ? category.name : "-"}</h2>
                                            <div className="divider mb-3"></div>
                                        </Col>
                                    </Row>
                                    {category && categoryQuestions? 
                                        <EntryFormV2 
                                            country={award.award_type.country} 
                                            awardData={award} 
                                            categoryId={category.id} 
                                            userType={`Entrant`} 
                                            onStep={(e) => setStep(e)}
                                            formData={formData}
                                            categoryQuestions={categoryQuestions}
                                            user_id={currentUser}
                                        />
                                        :
                                        null
                                    }
                                    
                                </Col>
                            </>
                        }
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default EntryFormPreviewPage;

